import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import CustomInput from "../../../../global/components/CustomInput/CustomInput";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import ShowAllStyles from "../ShowAll/ShowAll.styles";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";
import notifiers from "../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../utils/customErrorHandler";
import { AddLoanApi } from "./AddLoanServices";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";

interface CustomProps {
  isDialogOpenLoan: boolean;
  handleCloseLoan: Function;
  userId: string;
  status: any;
}

const AddLoan = (props: CustomProps) => {
  const [apiResponse, setApiResponse] = useState(false);
  const [formValues, setFormValues] = useState({
    loan_acc: "",
    loan_amt: "",
    loan_emi: "",
    start_from: "",
    updated_amt: "",
    status: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    loan_acc: "",
    loan_amt: "",
    loan_emi: "",
    start_from: "",
    updated_amt: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleFormSubmit = async () => {
    if (isFormValid()) {
      const body: any = {
        ...formValues,
        status: props?.status,
        userId: props?.userId,
      };
      try {
        setApiResponse(true);
        const response = await AddLoanApi(body);
        customErrorHandler(response);
        if (response?.success === 1) {
          openSuccessNotification(response?.message);
        }
        props.handleCloseLoan();
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }

      // Clear the form values after submission if needed
      setFormValues({
        loan_acc: "",
        loan_amt: "",
        loan_emi: "",
        start_from: "",
        updated_amt: "",
        status: "",
      });
      setValidationErrors({
        loan_acc: "",
        loan_amt: "",
        loan_emi: "",
        start_from: "",
        updated_amt: "",
      });
    }
  };

  const isFormValid = () => {
    let isValid = true;
    const errors = {
      loan_acc: "",
      loan_amt: "",
      loan_emi: "",
      start_from: "",
      updated_amt: "",
    };

    if (formValues.loan_acc.trim() === "") {
      errors.loan_acc = "Please enter loan Account.";
      isValid = false;
    }

    if (formValues.loan_amt.trim() === "") {
      errors.loan_amt = "Please enter loan amount.";
      isValid = false;
    }

    if (formValues.loan_emi.trim() === "") {
      errors.loan_emi = "Please enter loan EMI.";
      isValid = false;
    }

    if (formValues.start_from.trim() === "") {
      errors.start_from = "Please enter start date.";
      isValid = false;
    }

    if (formValues.updated_amt.trim() === "") {
      errors.updated_amt = "Please enter updated amount.";
      isValid = false;
    }

    setValidationErrors(errors);
    return isValid;
  };

  const classes = ShowAllStyles;

  const dialogHeaderContentLoan = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
      <CloseIcon onClick={() => props.handleCloseLoan()} />
    </Box>
    );
  };

  const dialogTitleContentLoan = () => {
    return (
      <>
        <Box sx={classes.content}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={classes.pageHeading}>Add Loan</Typography>
              <Typography sx={classes.pageSubHeading}>
                Change your account status
              </Typography>
            </Grid>
            <Grid container xs={6} rowSpacing={3} columnSpacing={5} mt={2}>
              <Grid item xs={6}>
                <CustomInput
                  label="Loan Account"
                  value={formValues.loan_acc}
                  onChange={handleInputChange}
                  name="loan_acc"
                  placeHolder="Loan Account"
                  error={validationErrors.loan_acc !== ""}
                  helperText={validationErrors.loan_acc}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomInput
                  type="number"
                  label="Loan Amount"
                  value={formValues.loan_amt}
                  onChange={handleInputChange}
                  name="loan_amt"
                  placeHolder="Loan Amount"
                  error={validationErrors.loan_amt !== ""}
                  helperText={validationErrors.loan_amt}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomInput
                  type="number"
                  label="Loan EMI"
                  value={formValues.loan_emi}
                  onChange={handleInputChange}
                  name="loan_emi"
                  placeHolder="Loan EMI"
                  error={validationErrors.loan_emi !== ""}
                  helperText={validationErrors.loan_emi}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomInput
                 type="date"
                  label="Start from"
                  value={formValues.start_from}
                  onChange={handleInputChange}
                  name="start_from"
                  placeHolder="Start from"
                  error={validationErrors.start_from !== ""}
                  helperText={validationErrors.start_from}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomInput
                  type="number"
                  label="Updated amount"
                  value={formValues.updated_amt}
                  onChange={handleInputChange}
                  name="updated_amt"
                  placeHolder="Updated amount"
                  error={validationErrors.updated_amt !== ""}
                  helperText={validationErrors.updated_amt}
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={classes.buttonWrapperDialog}>
                  
                <CustomButton
                    label="Cancel"
                    onClick={() => {
                      props.handleCloseLoan();
                    }}
                    buttonType="secondaryBtn"
                  />

                  <CustomButton
                    label="Submit"
                    onClick={handleFormSubmit}
                    buttonType="primaryBtn"
                  />
                
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  return (
    <>
      <CustomDialog
        fullScreen={true}
        isDialogOpen={props.isDialogOpenLoan}
        dialogHeaderContent={dialogHeaderContentLoan()}
        dialogTitleContent={dialogTitleContentLoan()}
        handleDialogClose={props.handleCloseLoan}
      />
      {apiResponse && <CustomLoader apiResponse={false} />}
    </>
  );
};

export default AddLoan;
